import { format, getTime, formatDistanceToNow } from 'date-fns';
import arLocale from 'date-fns/locale/ar-SA';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function jDate(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function jDateTime(date) {
  return format(new Date(date), 'dd MM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date, locale) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
    locale: locale === 'ar' ? arLocale : null,
  });
}

export function jDateTimeLocale(date, locale) {
  return format(new Date(date), 'dd MMMM yyyy p', { locale: locale === 'ar' ? arLocale : null });
}

export function jDateLocale(date, locale) {
  return format(new Date(date), 'dd MMMM yyyy', { locale: locale === 'ar' ? arLocale : null });
}

export function jDateFormatLocale(date, frmt, locale) {
  return format(new Date(date), frmt, { locale: locale === 'ar' ? arLocale : null });
}
